import { CompanySettings } from "../../utilities/types";
import { BaseDataModel } from "./base";

type portalConfigurationOption =
	| "Import: Agrian (Echelon)"
	| "Import: Agrian (Agellum)"
	| "Import: Proagrica"
	| "Import: CSV + SHP"
	| "Import: Manual Entry"
	| "Import: Agvance"
	| "Import: FieldAlytics"
	| "Submission: No Files Needed"
	| "Submission: Show Special Lab Instructions"
	| "Import: SHP";

export type AgrianType = "Echelon" | "Agellum";

export class Company extends BaseDataModel {
	name!: string;
	portalConfigurationOptions!: portalConfigurationOption[];
	portalSettings!: CompanySettings;
	softwaresActive!: string[];
	branchIds!: string[];
	dealIds!: string[];
	externalLocationId?: string[];
	isActive!: number;
	agrianType?: AgrianType;
}
